import { createToken } from "vue-stripe-elements-plus";
import { initValidateByPromise } from "../utils/errors";
import {
  stripePay as stripePayRes,
  paypalUrl as paypalUrlRes,
  paypalPay as paypalPayRes,
  cancel as cancelRes,
  history as historyRes,
  unsubscription as unsubscriptionRes,
} from "../api/payment";
import { updateCard as updateCardRes } from "../api/users";
import { updateUserInfo, initUserInfo } from "../service/user";
import {
  CURRENT_PUBLISHER_ID,
  CURRENT_USER_INFO_SIMPLE,
} from "../store/mutation-types";
import store from "../store/index";
import moment from "moment-timezone";
import { dateFormat } from "../utils/plugin_helper";
import fetch from "../utils/fetch";
/**
 * 更新信用卡信息
 * @returns {Promise<{code: number, msg: *}>}
 */
export async function updateCard() {
  const stripToken = await createToken();
  // 如果存在error则说明请求出错
  if (stripToken.error) {
    return initValidateByPromise(stripToken.error.message);
  } else {
    const token = stripToken.token;
    const { data } = await updateCardRes({ credit_card: token.id });
    await initUserInfo(data);
  }
}

/**
 * stripe 支付
 * @param id 支付方式唯一标示
 * @param name 用户姓名
 * @param card 信用卡号
 * @returns {Promise<*>}
 */
export async function stripePay({ id, name = "", card = "" }) {
  let token = "";
  if (name !== "") {
    const stripToken = await createToken();
    // 如果存在error则说明请求出错
    if (stripToken.error) {
      return initValidateByPromise(stripToken.error.message);
    } else {
      token = stripToken.token;
    }
  }
  let currentPublisherId = store.getters[CURRENT_PUBLISHER_ID];
  // 这里判断一下，如果是安卓那么传给
  // 如果是从active页面进入支付页面，则带上publisherId 反之则不带
  let stripePayParams = { plan_id: id, stripe_token: token.id, name };
  stripePayParams.publisherId = currentPublisherId;
  const { data } = await stripePayRes(stripePayParams);
  await updateUserInfo({});
  return data;
}

/**
 * 获取paypal 支付地址
 * @param id 支付方式唯一标示
 * @param sale 支付失败时sale = true
 * @returns {Promise<*>}
 */
export async function paypalUrl({ id, sale = false }) {
  // 获取paypal地址
  const { data } = await paypalUrlRes({ plan_id: id, sale });
  return data.approval_url;
}

/**
 * 通过paypal进行订阅
 * @param token paypal回调之后token
 * @param paymentId paypal回调之后paymentId
 * @param PayerID paypal回调之后PayerID
 * @returns {Promise<void>}
 */
export async function paypalPay({ token, paymentId, PayerID }) {
  const publisherId = store.getters[CURRENT_PUBLISHER_ID];
  const { data } = await paypalPayRes({
    paypal_token: token,
    publisherId,
    payment_id: paymentId,
    payer_id: PayerID,
  });
  await updateUserInfo({});
  return data;
}

/**
 * 提交意见反馈
 * @param  feedback 发送的意见
 * @param type 意见提交类型
 * Cancelled: 用户最终确认取消。
 * Closed: 用户退出了取消订阅页面，没有接受优惠，也没有选择取消订阅。
 * Accepted LTO: 接受了限时优惠。

 */
export async function sendFeedback({ feedback, type = "Closed" }) {
  return fetch.post("users/self/feedbacks/quick-question", {
    Field101: feedback,
    Field103: store.getters[CURRENT_USER_INFO_SIMPLE].email,
    Field105: type,
  });
}
/**
 * 取消当前订阅
 * @returns {Promise<void>}
 */
export async function cancel({ feedback }) {
  await cancelRes({ feedback });
  await updateUserInfo({});
}
/**
 * 接受半价优惠
 * @param feedback 填写的意见
 */
export async function unsubscription({ feedback }) {
  await unsubscriptionRes({ unsubscription: true, feedback });
  await updateUserInfo({});
}

/**
 * 获取当前用户历史支付记录
 * @returns {Promise<*>}
 */
export async function history({ limit = 100, offset = 0 }) {
  const format = (str) => {
    // 寻找{
    const leftIndex = str.indexOf("{");
    if (leftIndex === -1) {
      return str;
    }
    const rightIndex = str.indexOf("}", leftIndex);
    const time = str.substring(leftIndex + 1, rightIndex);
    const date = dateFormat({ date: moment(time), format: "MMM DD, YYYY" });
    return (
      str.substring(0, leftIndex) +
      date +
      str.substring(rightIndex, str.length - 1)
    );
  };
  const { data } = await historyRes({ limit, offset });
  const result = data.map((h) => {
    const date = dateFormat({
      date: moment(h.date_created),
      format: "MMMM DD, YYYY",
    });
    return {
      title: format(h.message), // September 14, 2017
      date,
    };
  });
  return result;
}
